import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { LocationResponse } from "../../shared/models/location.model";
import { LocationService } from "../../shared/services/location.service";

@Injectable({
    providedIn: 'root',
})
export class GetLocationResolver implements Resolve<LocationResponse[]> {

    constructor(private locationService: LocationService) { }

    resolve(): Observable<LocationResponse[]> {
        return this.locationService.getAll();
    }
}
    
